import React, { useState } from 'react';

export interface SettingsSideBarItemProps {
  iconLeft: React.ReactNode;
  text: string;
  selected: boolean;
  onClick?: (event: any) => void;
  className?: string;
  textClassName?: string;
  danger?: boolean;
}

export const SettingsSideBarItem: React.FC<SettingsSideBarItemProps> = ({
  iconLeft,
  text,
  selected,
  onClick,
  className,
  textClassName,
  danger,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`w-full h-8 flex items-center justify-center gap-2 pl-2 cursor-pointer rounded-lg bg-brand-white outline ${selected ? 'outline-1 outline-taskonioGreen-200 bg-taskonioGreen-100' : isHovered ? 'outline-1 outline-neutral-200' : 'outline-none'} ${isHovered ? 'bg-neutral-100' : ''} ${className}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Fixed 16px icon box so every row's label starts at the same x, regardless
          of whether the icon is a 16px custom SVG or a ~14px AntD icon (#2686). */}
      <div
        className={`w-4 h-4 shrink-0 flex items-center justify-center ${danger ? 'text-red-600' : selected ? 'text-brand-grey-dark' : 'text-neutral-900'}`}
      >
        {iconLeft}
      </div>
      <div
        className={`text-sm flex-1 overflow-hidden text-ellipsis whitespace-nowrap ${textClassName || 'font-normal'} ${danger ? 'text-red-600' : selected ? 'text-brand-grey-dark' : 'text-neutral-900'}`}
      >
        {text}
      </div>
    </div>
  );
};

export default SettingsSideBarItem;
